module.exports = {"id":"178251","name":"Romain Danzé","rating":"72","photo":"./data/images/photos/1/178251.png","club":{"name":"Stade Rennais","logo":"./data/images/clubs/StadeRennais.png"},"positions":["DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RomainDanze0.json
// module id = 3685
// module chunks = 0